import type { IDataSourceItem } from "./types";

import React, { useState } from "react";
import { cx } from "@/lib/utils";

import Image, { StaticImageData } from "next/image";

interface DataSourceCardProps extends Omit<IDataSourceItem, 'icon'> {
    className?: string;
    icon: StaticImageData | string | React.ReactNode;
    fallbackIcon?: React.ReactNode;
    style?: React.CSSProperties;
}

export const DataSourceCard = ({ id, label, icon, isHub, disabled, className, style, fallbackIcon }: DataSourceCardProps) => {
    const [imageError, setImageError] = useState(false);
    
    return (
        <div id={id} className={cx("flex items-center", disabled && "opacity-30 filter grayscale", className)} style={style}>
            <div className={cx("min-h-[83px] max-h-[83px] w-[113px] flex flex-col items-center rounded-lg", isHub ? "bg-[#35434a]" : "bg-[#d3dfe880]")}>
                <div
                    className={cx(
                        "h-[63px] self-stretch flex flex-row justify-center items-center p-[10px] rounded-lg border-[#d3e2e8] border-solid",
                        !isHub && "m-px",
                        isHub ? "bg-[linear-gradient(119deg,#2a8f9a_0%,#f0c13e_95%)]" : "bg-[#fff]"
                    )}
                >
                    <div className="relative w-full h-full">
                    {!imageError && (typeof icon === 'string' || (icon as StaticImageData)?.src) ? (
                        <Image 
                            src={icon as StaticImageData} 
                            alt={`Data Source ${label}`} 
                            objectFit="contain" 
                            fill 
                            onError={() => setImageError(true)}
                        />
                    ) : (
                        <div className="w-full h-full flex items-center justify-center">
                            {imageError && fallbackIcon ? fallbackIcon : (icon as React.ReactNode)}
                        </div>
                    )}
                </div>
                </div>
                <p className={cx("mt-px text-[10px] font-medium leading-relaxed text-center uppercase", isHub ? "text-[#fff]" : "text-[#000]")}>{label}</p>
            </div>
        </div>
    );
};
